import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const translations = require("./translations.json");

i18n.use(initReactI18next).init({
  resources: translations,
  lng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
